module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"addUserDialog_Header":"Crea Nuovo Paziente","createuser_Success":"Utente creato!","createuser_Error":"Utente non creato!","Name":"Nome","Surname":"Cognome","FullName":"Nome Cognome","formCreateUser":{"Name":"Nome","Surname":"Cognome","UserName":"Nome Utente","Email":"Email","Password":"Password","UseCompanyAlias":"Usa nome azienda","CompanyAlias":"Nome azienda"}}}')
  delete Component.options._Ctor
}
